<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wode/pending/inventory/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('rukuzuzhi')">
            <el-input v-model="yt.conditions.fStockOrgId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchanzuzhi')">
            <el-input v-model="yt.conditions.fPrdOrgId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('huozhu')">
            <el-input v-model="yt.conditions.fOwnerId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchanrukuleixing')">
            <yi_dictionary_select :max="999" multiple clearable="false" :type="'WODE_PRO_RECEIPT_TYPE'" :ids.sync="yt.conditions.proReceiptTypes"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shengchanongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :component="'web_base_equipment_list'" multiple :ids.sync="yt.conditions.equipmentIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('tibaoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.reportCreateTimeStart" :end.sync="yt.conditions.reportCreateTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="yt.conditions.createByNickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('liangpinrukuzhuangtai')">
            <yi_dictionary_select :max="999" multiple clearable="false" :type="'WODE_PEDING_INVENTORY_GOOD_STATUS'" :ids.sync="yt.conditions.goodStatusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('buliangpinrukuzhuangtai')">
            <yi_dictionary_select :max="999" multiple clearable="false" :type="'WODE_PEDING_INVENTORY_BAD_STATUS'" :ids.sync="yt.conditions.badStatusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('baogongdanhao')">
            <el-input v-model="yt.conditions.woReportRecordNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuadanbumen')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.includeOrgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tichujihuadanbumen')">
            <yi_data_select multiple :type="'organization'" :ids.sync="yt.conditions.excludeOrgIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
            <el-input v-model="yt.conditions.erpRequireSourceNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('MESID')">
            <el-input v-model="yt.conditions.id"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="search" type="primary" plain :loading="yt.loading">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ reportCreateTimeStart: begin(), reportCreateTimeEnd: end() })" :loading="yt.loading">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #shifoubulu="scope">
        {{ scope.row.reportType == 0 ? $t('fou') : $t('shi') }}
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <!--良品入库车间审核-->
        <el-button size="mini" type="primary" @click="getGoodCheckInWorkshop" :disabled="checkDisabled" :loading="goodInWorkshopLoading" v-if="utils.checkPower('web_production_management_pending_receipt_order_checkInWorkshop')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-良品入库车间审核' } }">
          {{ $t('laingpinrukuchejianshenhe') }}
        </el-button>
        <!--良品入库仓库审核-->
        <el-button size="mini" type="primary" @click="getGoodCheckInWarehouse" :disabled="checkDisabled" :loading="goodInWarehouseLoading" v-if="utils.checkPower('web_production_management_pending_receipt_order_checkInWarehouse')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-良品入库仓库审核' } }">
          {{ $t('laingpinrukucangkushenhe') }}
        </el-button>
        <!--不良品入库车间审核-->
        <el-button size="mini" type="danger" @click="getBadCheckInWorkshop" :disabled="checkDisabled" :loading="badInWorkshopLoading" v-if="utils.checkPower('web_production_management_pending_receipt_order_checkInWorkshop_bad')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-不良品入库车间审核' } }">
          {{ $t('buliangpinrukuchejianshenhe') }}
        </el-button>
        <!--不良品入库仓库审核-->
        <el-button size="mini" type="danger" @click="getBadCheckInWarehouse" :disabled="checkDisabled" :loading="badInWarehouseLoading" v-if="utils.checkPower('web_production_management_pending_receipt_order_checkInWarehouse_bad')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-不良品入库仓库审核' } }">
          {{ $t('buliangpinrukucangkushenhe') }}
        </el-button>
        <!--良品入库驳回rejectReportGoodQuantity-->
        <el-button size="mini" type="warning" @click="yt.showEditDialog('liangpinruku', null, 'w1')" :disabled="checkDisabled" :loading="rejectReportGoodQuantityLoading" v-if="utils.checkPower('web_production_management_pending_receipt_order_reject_good')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-良品入库驳回' } }">
          {{ $t('liangpinrukubohui') }}
        </el-button>

        <!-- 员工确认 -->
        <el-popconfirm style="padding-left: 10px;" :confirm-button-text="$t('queding')" :cancel-button-text="$t('quxiao')" icon="el-icon-info" icon-color="red" :title="$t('quedingma?')" @confirm="employeeConfirm">
          <el-button slot="reference" size="mini" type="warning" :disabled="checkDisabled" :loading="employeeConfirmLoading" v-if="utils.checkPower('web_production_management_pending_receipt_order_employeeConfirm_wd')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '待入库单-员工确认' } }">
            {{ $t('yuangongqueren') }}
          </el-button>
        </el-popconfirm>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #liangpinshuliangqueren="scope">
        <span v-if="scope.row.goodStatus !== '3'" @click="yt.showEditDialog('liangpinshuliangqueren', scope.row, 'w1')" style="color: #419FFF; cursor: pointer;">
          {{ scope.row.goodQuantityConfirmed }}
        </span>
        <span v-else style="color: #606266;">
          {{ scope.row.goodQuantityConfirmed }}
        </span>
      </template>
      <template #buliangpinshuliangqueren="scope">
        <span v-if="scope.row.goodStatus !== '3'" @click="yt.showEditDialog('buliangpinshuliangqueren', scope.row, 'w1')" style="color: #419FFF; cursor: pointer;">
          {{ scope.row.badQuantityConfirmed }}
        </span>
        <span v-else style="color: #606266;">
          {{ scope.row.badQuantityConfirmed }}
        </span>
      </template>
      <template #zhijianbeizhu="scope">
        <span @click="yt.showEditDialog('zhijianbeizhu', scope.row, 'w1')" style="color: #419FFF; cursor: pointer;">
          {{ scope.row.qualityRemark==null||scope.row.qualityRemark==''?$t('lurubeizhu'):scope.row.qualityRemark }}
        </span>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'liangpinruku'">
        <div>
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('bohuiyuanyin')" required>
              <el-input v-model="rejectReason"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="rejectReportGoodQuantityLoading" size="mini" @click="rejectReportGoodQuantity" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'liangpinshuliangqueren'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('liangpinshuliangqueren')" required>
              <el-input v-model="yt.editObj.goodQuantityConfirmed" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/wode/pending/inventory/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'buliangpinshuliangqueren'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('buliangpinshuliangqueren')" required>
              <el-input v-model="yt.editObj.badQuantityConfirmed" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/wode/pending/inventory/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'zhijianbeizhu'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('zhijianbeizhu')" required>
              <el-input type = "textarea" :autosize="{ minRows: 17, maxRows: 17}" maxlength="200" v-model="yt.editObj.qualityRemark" show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveQualityRemark" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_production_management_pending_receipt_order_list',

  data() {
    return {
      rejectReason: '',
      goodInWorkshopLoading: false,
      goodInWarehouseLoading: false,
      badInWorkshopLoading: false,
      badInWarehouseLoading: false,
      rejectReportGoodQuantityLoading: false,
      employeeConfirmLoading: false,
      list: [],
      ids: [],
      checkDisabled: true,
      totalExtend: {},
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'MESID',
          prop: 'id'
        },
        {
          label: 'liangpinrukuzhuangtai',
          prop: 'goodStatus',
          type: 'dictionary',
          key: 'WODE_PEDING_INVENTORY_GOOD_STATUS',
          width: 130
        },
        {
          label: 'buliangpinrukuzhuangtai',
          prop: 'badStatus',
          type: 'dictionary',
          key: 'WODE_PEDING_INVENTORY_BAD_STATUS',
          width: 130
        },
        {
          label: 'liangpinrukujiekouzhuangtai',
          prop: 'goodInterfaceStatus',
          type: 'dictionary',
          key: 'WODE_INTERFACE_STATUS',
          width: 150
        },
        {
          label: 'buliangpinrukujiekouzhuangtai',
          prop: 'badInterfaceStatus',
          type: 'dictionary',
          key: 'WODE_INTERFACE_STATUS',
          width: 150
        },
        // {
        //   label: 'jiekouzhuangtai',
        //   prop: 'interfaceStatus',
        //   type: 'dictionary',
        //   key: 'WODE_INTERFACE_STATUS',
        //   // width: 130,
        // },
        {
          label: 'liangpinshuliangqueren',
          prop: 'goodQuantityConfirmed',
          type: 'slot',
          width: 130
        },
        {
          label: 'buliangpinshuliangqueren',
          prop: 'badQuantityConfirmed',
          type: 'slot',
          width: 130
        },
        {
          label: 'zhijianbeizhu',
          prop: 'qualityRemark',
          type: 'slot',
          width: 150
        },
        {
          label: 'rukuzuzhi',
          prop: 'FStockOrgId',
          width: 130
        },
        {
          label: 'shengchanzuzhi',
          prop: 'FPrdOrgId',
          width: 130
        },
        {
          label: 'huozhu',
          prop: 'FOwnerId',
          width: 130
        },
        {
          label: 'shengchanrukuleixing',
          prop: 'proReceiptType',
          type: 'dictionary',
          key: 'WODE_PRO_RECEIPT_TYPE',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 150
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 150
        },
        {
          label: 'erpxuqiulaiyuandanhao',
          prop: 'plan.erpRequireSourceNo',
          width: 150
        },
        {
          label: 'baogongdanhao',
          prop: 'woReportRecordNo',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 150
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 150
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          width: 150
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'guige',
          prop: 'material.spec',
          width: 150
        },
        {
          label: 'yanse',
          prop: 'material.color',
          width: 150
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient',
          width: 150
        },
        {
          label: 'gongxugongdan',
          prop: 'woProcedure.no',
          width: 150
        },
        {
          label: 'gongxumiaoshu',
          prop: 'woProcedure.procedureDesc',
          width: 150
        },
        {
          label: 'baogongshuliang',
          prop: 'reportQuantity',
          width: 150
        },
        {
          label: 'buliangshuliang',
          prop: 'badQuantity',
          width: 150
        },
        {
          label: 'liangpinshuliang',
          prop: 'goodQuantity',
          width: 150
        },
        {
          label: 'baogongriqi',
          prop: 'reportDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 150
        },
        {
          label: 'baogongbanci',
          prop: 'shift.name',
          width: 150
        },
        {
          label: 'tibaoshijian',
          prop: 'reportCreateTime',
          type: 'time',
          width: 180
        },
        {
          label: 'chejianshenheshijian',
          prop: 'workShopCheckTime',
          type: 'time',
          width: 180
        },
        {
          label: 'cangkushenheshijian',
          prop: 'wareHouseCheckTime',
          type: 'time',
          width: 180
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'jihuadanbumen',
          prop: 'orgName',
          width: 150
        },
        {
          label: 'shifoubulu',
          prop: 'reportType',
          type: 'slot',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 150
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        //表格默认按提报时间降序排序。
        orderBy: 'reportCreateTime desc'
      };
      this.yt.get(1, this.beforeGet);
      this.yt.isShowSummary = true;
      this.yt.getSummaries = this.getSummaries;
      this.$set(this.yt.conditions, 'reportCreateTimeStart', this.begin());
      this.$set(this.yt.conditions, 'reportCreateTimeEnd', this.end());
      // 获取缓存的剔除计划单部门
      const excludeOrgIds = localStorage.getItem('multipleOrgIds') || [];
      this.$set(this.yt.conditions, 'excludeOrgIds', JSON.parse(excludeOrgIds));
    }, 300);
  },
  methods: {
    // 员工确认
    employeeConfirm() {
      this.employeeConfirmLoading = true;
      let params = {
        ids: this.ids
      };
      this.http
        .post('/custom/production/wode/pending/inventory/employee/confirm', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.employeeConfirmLoading = false;
        });
    },
    // 搜索
    search() {
      // 缓存剔除计划单部门
      const excludeOrgIds = this.yt.conditions.excludeOrgIds || [];
      localStorage.setItem('multipleOrgIds', JSON.stringify(excludeOrgIds));
      this.yt.get(1);
      this.ids = [];
    },
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
      if (this.ids.length > 0) {
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
      }
    },
    beforeGet(params) {
      params['reportCreateTimeStart'] = this.begin();
      params['reportCreateTimeEnd'] = this.end();
      return params;
    },

    exportExcel() {
      let params = this.yt.conditions;
      this.yt.exportLoading = true;
      return this.http
        .get('/web/report/export/wode_pending_inventory_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.yt.exportLoading = false;
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = date.getTime();
      return end;
    },
    //入库仓库审核（良品）
    getGoodCheckInWarehouse() {
      this.goodInWarehouseLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 1
      };
      this.http
        .post('/custom/production/wode/pending/inventory/checkInWarehouse', params)
        .then(res => {
          this.goodInWarehouseLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(error => {
          this.goodInWarehouseLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    //入库仓库审核（不良品）
    getBadCheckInWarehouse() {
      this.badInWarehouseLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 2
      };
      this.http
        .post('/custom/production/wode/pending/inventory/checkInWarehouse', params)
        .then(res => {
          this.badInWarehouseLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(error => {
          this.badInWarehouseLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    //入库车间审核（良品）
    getGoodCheckInWorkshop() {
      this.goodInWorkshopLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 1
      };
      this.http
        .post('/custom/production/wode/pending/inventory/checkInWorkshop', params)
        .then(res => {
          this.goodInWorkshopLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(error => {
          this.goodInWorkshopLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    //入库车间审核（不良品）
    getBadCheckInWorkshop() {
      this.badInWorkshopLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 2
      };
      this.http
        .post('/custom/production/wode/pending/inventory/checkInWorkshop', params)
        .then(res => {
          this.badInWorkshopLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(error => {
          this.badInWorkshopLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    //良品入库驳回
    rejectReportGoodQuantity() {
      this.rejectReportGoodQuantityLoading = true;
      let params = {
        ids: this.ids,
        rejectReason: this.rejectReason
      };
      this.http
        .post('/custom/production/wode/pending/inventory/rejectReportGoodQuantity', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.rejectReportGoodQuantityLoading = false;
        });
    },

    getSummaries(params) {
      const { columns, data } = params;
      const sums = [];
      // 1. 获取当前选中的行（通过 ids 匹配）
      const selectedRows = data.filter(item => this.ids.includes(item.id));

      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '合计：';
          return;
        }

        // 2. 仅对指定列进行统计
        if (column.property === 'goodQuantityConfirmed' || column.property === 'badQuantityConfirmed') {
          // 3. 计算选中行的总和
          const total = selectedRows.reduce((sum, row) => {
            const value = Number(row[column.property]);
            return isNaN(value) ? sum : sum + value;
          }, 0);

          sums[index] = total;
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    saveQualityRemark(){
      if(this.yt.editObj.qualityRemark.length > 200){
        this.utils.errorMessage(this.$t('beizhuchangduzuidawei')+'200');
      }
      this.yt.req('POST', '/web/production/wode/pending/inventory/update');
    },

    // exportExcel() {
    //   let params = this.yt.conditions
    //   return this.http.get('/custom/report/page/dead_inventory_report', {
    //     params
    //   }).then(res => {
    //     this.$message.success(this.$t(res.msg))
    //     this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
    //   }).catch(error => {
    //     this.$message.error(this.$t(error))
    //   })
    // },
  }
};
</script>
